import { COUNTRY_OPTIONS } from "../../../utils/constants";

export const getTotalPopulation = (campaignRules = []) =>
  campaignRules
    ?.filter(
      (ruleData) =>
        ruleData?.ruleDefinition?.slug === "user-segment-for-gift-processing"
    )
    ?.reduce((total, ruleData) => {
      const userCount = Number(ruleData?.ruleData?.total_unique_users) || 0;
      return total + userCount;
    }, 0);

export const getCountryName = (countryCode, schemaOptions = []) => {
  const fromSchema = schemaOptions.find(
    (item) => item.id === countryCode
  )?.displayText;
  if (fromSchema) return fromSchema;
  return COUNTRY_OPTIONS.find((item) => item.id === countryCode)?.displayText || "";
};
